import { getStore } from '@repo/api-adapters/store-details';
import { useQuery } from '@tanstack/react-query';

import { API } from './utils.api';

export const useStoreDetails = (storeDetailsBasePath: string, buCode: string) => {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    return useQuery({
        queryKey: [API.store, buCode],
        enabled: Boolean(buCode),
        queryFn: () => getStore(storeDetailsBasePath, buCode),
    });
};
